const bs58 = require('base-58')
const sha256 = require('sha256')

class MiscService {
  toHexString (byteArray) {
    return Array.from(byteArray, function (byte) {
      return ('0' + (byte & 0xFF).toString(16)).slice(-2)
    }).join('')
  }

  getAddress (pkh, moneybox) {
    var mb_pkh = bs58.decode(moneybox)
    var s1
    if (mb_pkh[2] === 0xa5) {
      s1 = '02D0A4'
    } else if (mb_pkh[2] === 0xa9) {
      s1 = '02D0A8'
    } else {

    }

    s1 = s1.concat(pkh)
    var hash = sha256.x2(Buffer.from(s1, 'hex')).slice(0, 8)
    var zero = Buffer.from(s1.concat(hash), 'hex')
    return bs58.encode(zero)
  }

  parseLockedScript (script) {
  //   const lockedPattern = /([0-9]{10}) OP_CHECKLOCKTIMEVERIFY OP_DROP OP_DUP OP_HASH160 [0-9a-f]{40} OP_EQUALVERIFY OP_CHECKSIG/g
    const lockedPattern = /([0-9]{10}) OP_CHECKLOCKTIMEVERIFY/g
    return lockedPattern.exec(script)
  }

  parseFundingScript (script) {
    const fundPattern = /OP_DUP OP_HASH160 ([0-9a-f]{40}) OP_EQUAL OP_IF OP_CHECKSIG OP_ELSE OP_OVER OP_HASH160 ([0-9a-f]{40}) OP_EQUALVERIFY OP_DUP OP_HASH160 ([0-9a-f]{40}) OP_EQUALVERIFY 2 OP_CHECKMULTISIG OP_ENDIF/g
    return fundPattern.exec(script)
  }

  parseAbMintingScript (script) {
    const fundPattern = /OP_DUP OP_HASH160 ([0-9a-f]{40}) OP_EQUAL OP_IF ([0-9]{10}) OP_CHECKLOCKTIMEVERIFY OP_DROP OP_CHECKSIG OP_ELSE OP_OVER OP_HASH160 ([0-9a-f]{40}) OP_EQUALVERIFY OP_DUP OP_HASH160 ([0-9a-f]{40}) OP_EQUALVERIFY 2 OP_CHECKMULTISIG OP_ENDIF/g
    return fundPattern.exec(script)
  }

  checkModifyTxAndOutput (item, index, object, rawtx, moneybox, tx) {
    if (item.value === 0) {
      object.splice(index, 1)
    } else {
      let res = null
      let isLocked = null
      switch (rawtx.vout[index].scriptPubKey.type) {
        case 'funding':
          res = this.parseFundingScript(rawtx.vout[index].scriptPubKey.asm)
          if (res) {
            item.address = this.getAddress(res[3], moneybox)
            tx.type = 'standard'
            tx.additional = []
          }
          break

        case 'ab_minting':
          res = this.parseAbMintingScript(rawtx.vout[index].scriptPubKey.asm)
          if (res) {
            item.address = this.getAddress(res[1], moneybox)
            isLocked = res[2]
            tx.type = 'standard'
            tx.additional = []
          }
          break

        default:
          res = this.parseLockedScript(rawtx.vout[index].scriptPubKey.asm)
          if (res) {
            isLocked = res[1]
          }
          break
      }

      if (isLocked) {
        var ts = Number(Math.round((new Date()).getTime() / 1000))
        var lt = Number(isLocked)

        if (ts > lt) {
          item.locked_coin = false
        } else {
          item.locked_coin = true
        }
      }
    }
    return item
  }
}

export default new MiscService()



// WEBPACK FOOTER //
// ./src/service/MiscService.js